import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userData: null,
  token: "",
  refreshToken: "",
  productItem: null,
};

export const userDataSlice = createSlice({
  name: "userDataSlice",
  initialState,
  reducers: {
    setUserData: (state, action) => {
      state.userData = action.payload;
    },
    setAccessToken: (state, action) => {
      state.token = action.payload;
    },
    setRefreshToken: (state, action) => {
      state.refreshToken = action.payload;
    },
    setProductItem: (state, action) => {
      state.productItem = action.payload;
    },
    clearAll: (state) => {
      state.userData = null;
      state.token = "";
      state.refreshToken = "";
      state.productItem = null;
    },
  },
});

export const {
  setUserData,
  setAccessToken,
  setRefreshToken,
  setProductItem,
  clearAll,
} = userDataSlice.actions;

export default userDataSlice.reducer;
